export default "__VITE_ASSET__4c99d945__"